import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'tooglebutton',
    templateUrl: './tooglebutton.component.html',
    styleUrls: ['./tooglebutton.component.scss'],
})
export class TooglebuttonComponent implements OnInit {
    @Input()
    position: boolean = false;

    @Output()
    positionChange = new EventEmitter<boolean>();

    isClicked = new EventEmitter<void>();

    constructor() {}

    change() {
        this.position = !this.position;
        this.positionChange.emit(this.position);
    }

    positionChanged() {
        this.isClicked.emit();
    }

    ngOnInit(): void {}
}
